module.exports = __webpack_public_path__ + "img/02.650e0683.png";